export enum TeamProfileErrorType {
	TEAM_MISSING = 'teamMissing',
	NO_PERMISSION = 'noPermission',
	TEAM_DELETED = 'deleted',
	UNKNOWN = 'unknown',
	NO_ACCESS_TO_TEAMS = 'noAccessToTeams',
}
